import React, { useState } from 'react';
import { Layout, Package, Truck, BarChart, FileText, Settings, Plus, Warehouse } from 'lucide-react';
import { motion } from 'framer-motion';
import WarehouseOverview from './components/overview/WarehouseOverview';
import SpatialLocationManagement from './components/location/SpatialLocationManagement';
import WarehouseInventory from './components/inventory/WarehouseInventory';
import WarehouseOperations from './components/operations/WarehouseOperations';
import WarehouseAnalytics from './components/analytics/WarehouseAnalytics';
import WarehouseReports from './components/reports/WarehouseReports';
import WarehouseSettings from './components/settings/WarehouseSettings';

const WarehouseDashboard = () => {
  const [activeTab, setActiveTab] = useState('overview');

  const tabs = [
    { id: 'overview', label: 'Overview', icon: Layout },
    { id: 'location', label: 'Location Management', icon: Warehouse },
    { id: 'inventory', label: 'Inventory', icon: Package },
    { id: 'operations', label: 'Operations', icon: Truck },
    { id: 'analytics', label: 'Analytics', icon: BarChart },
    { id: 'reports', label: 'Reports', icon: FileText },
    { id: 'settings', label: 'Settings', icon: Settings }
  ];

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="bg-gradient-to-r from-orange-600 to-amber-700 rounded-xl p-6 text-white">
        <div className="flex justify-between items-start">
          <div>
            <h1 className="text-2xl font-semibold">Warehouse Management System</h1>
            <p className="text-orange-100 mt-1">Complete warehouse operations, inventory tracking, and capacity management</p>
          </div>
          <button
            onClick={() => {
              setActiveTab('operations');
              // Scroll to top after tab change
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
            className="px-4 py-2 bg-white text-orange-700 rounded-lg hover:bg-orange-50 transition-colors flex items-center gap-2 font-medium"
          >
            <Plus className="w-5 h-5" />
            New Receiving
          </button>
        </div>

        {/* Centered Tabs */}
        <div className="mt-6 flex justify-center">
          <div className="inline-flex space-x-1 bg-white/10 rounded-lg p-1 backdrop-blur-sm">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                    activeTab === tab.id
                      ? 'bg-white text-orange-700'
                      : 'text-white/90 hover:bg-white/10'
                  }`}
                >
                  <Icon className="w-4 h-4" />
                  {tab.label}
                </button>
              );
            })}
          </div>
        </div>
      </div>

      {/* Tab Content */}
      <div className="space-y-6">
        {activeTab === 'overview' && <WarehouseOverview />}
        {activeTab === 'location' && <SpatialLocationManagement />}
        {activeTab === 'inventory' && <WarehouseInventory />}
        {activeTab === 'operations' && <WarehouseOperations />}
        {activeTab === 'analytics' && <WarehouseAnalytics />}
        {activeTab === 'reports' && <WarehouseReports />}
        {activeTab === 'settings' && <WarehouseSettings />}
      </div>
    </div>
  );
};

export default WarehouseDashboard;
